import script from "./pv-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./pv-details.vue?vue&type=script&lang=ts&setup=true"

import "./pv-details.vue?vue&type=style&index=0&id=f5564410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5564410"]])

export default __exports__